module.exports = __webpack_public_path__ + "img/ky.84fc6098.png";